<template>
  <div v-if="appReady" id="ne-inner-app-wrapper">
    <template v-if="isFirstDomain || isSecondDomain">
      <div v-if="isMaintenance" class="maintenace-wrapper">
        <h1>We're undergoing scheduled maintenance to ensure optimal performance. <br/>
          Thank you for your patience as we work to enhance our services.</h1>
      </div>  
      <router-view v-else />
      <div v-if="loading" class="loading-container">
        <b-spinner variant="primary" :style="{ width: '80px', height: '80px' }" />
      </div>
      <Promo />
      <VideoPopup />
    </template>
    <div v-else class="text-center d-flex flex-column align-items-center justify-content-center" :style="{ height: '100vh' }">
      <h1 class="text-danger mt-0 mb-0">404</h1>
      <h4>Page not found</h4>
    </div>
  </div>
  <div v-else class="text-center pt-3"><b-spinner /></div>
</template>

<script>
import '@design'
export default {
  components: {
    Promo: () => import('@components/Common/Promo.vue'),
    VideoPopup: () => import('@components/Common/VideoPopup.vue')
  },
  data() {
    return {
      appReady: false
    }
  },
  computed: {
    isMaintenance() { return process.env.VUE_APP_MAINTENANCE === 'true' },
    user() { return this.$store.getters['auth/user'] },
    loading() { return this.$store.getters['app/loading'] },
    domainType: {
      get() { return this.$store.getters['app/domainType'] },
      set(value) { this.$store.dispatch('app/setDomainType', value) }
    },
    isLocalhost: {
      get() { return this.$store.getters['app/isLocalhost'] },
      set(value) { this.$store.dispatch('app/setIsLocalhost', value) }
    },
    isFirstDomain() {
      return process.env.VUE_APP_DOMAIN === location.hostname
    },
    isSecondDomain() {
      return process.env.VUE_APP_DOMAIN2 === location.hostname
    }
  },
  watch: {
    $route(to, from) {
      let namesDisabled = [ 'agency.cards.create', 'agency.cards.edit', 'agency.cards.preview' ]
      if (this.user && this.user.role === 'Agency' && to.name && (!to.name.includes('.design') && !to.name.includes('.sandbox_design') && !namesDisabled.includes(to.name))) {
        this.install_support_script()
      } else {
        this.destroy_support_script()
      }
    }
  },
  created() {
    window.fwSettings = { widget_id: 69000002181 }
  },
  mounted() {
    this.initComponent()
  },
  methods: {
    async initComponent() {
      if (window.location.search) {
        const params = new URLSearchParams(window.location.search)
        const hash = params.get('hash')
        const redirectUrl = params.get('redirect_url')
        // Force Login Check
        if (hash && redirectUrl) {
          const parts = window.atob(hash).split('[sep]')
          if (parts && parts.length === 2) {
            const email = parts[0]
            const uid = parts[1]
            await this.checkValidity({ email, uid })
          }
          window.location.href = redirectUrl
          return
        }
      }
      if (this.isFirstDomain) {
        this.domainType = 'first'
      } else if (this.isSecondDomain) {
        this.domainType = 'second'
      }
      this.isLocalhost = process.env.VUE_APP_DOMAIN === 'localhost'
      this.$store
        .dispatch('app/getConfig')
        .then(() => this.appReady = true)
        .catch(() => this.appReady = true)
    },
    checkValidity(params) {
      return new Promise((resolve) => {
        this.$store
          .dispatch('auth/checkValidity', params)
          .then(() => resolve(true))
          .catch(() => resolve(false))
      })
    },
    install_support_script() {
      if (!window.FreshworksWidget) {
        eval(`!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://widget.freshworks.com/widgets/69000002181.js",e.parentNode.insertBefore(n,e)}if(e.FreshworksWidget=n=function(t,n,a){e.FreshworksWidget.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.FreshworksWidget||function(){});window.FreshworksWidget('boot')`)
      }
    },
    destroy_support_script() {
      if (window.FreshworksWidget) {
        window.FreshworksWidget('destroy')
        window.FreshworksWidget = undefined
      }
    }
  }
}
</script>